import { IconBolt, IconUsers, IconCalendar } from '@tabler/icons-react';
import { automationsLive } from './automations';

// Unreleased Studio features listed in the sidebar; each opens a FeaturePreview modal.
// "Personalidade" (My Voice before) left this list: it is the composer's personality button
// (dialogs/PersonalityDialog). Automations leave it wherever their routes answer (enums/automations.js).
export const futureFeatures = [...(automationsLive ? [] : [['automations', IconBolt]]), ['leads', IconUsers], ['calendar', IconCalendar]];
